import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { GetJobResponse, HttpResponse } from "@/types";

export function useGetJob({
  companyId,
  jobId,
  placeholderData,
}: {
  companyId: string;
  jobId: string;
  placeholderData?: (
    previousData: GetJobResponse | undefined,
  ) => GetJobResponse | undefined;
}) {
  return useQuery({
    queryKey: ["job", companyId, jobId],
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}`;
      const res = await guacHttpClient.get<
        GetJobResponse,
        HttpResponse<GetJobResponse>
      >(path);
      return res.data;
    },
    placeholderData,
  });
}
